import React from "react";
import styles from "./HeroSection.module.scss";

interface HeroSectionProps {
  title: string;
  subtitle: string;
  backgroundImage: string;
  overlayOpacity?: number;
  textAlign?: "left" | "center" | "right";
  minHeight?: string;
  animateTitle?: boolean;
  animateSubtitle?: boolean;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  backgroundImage,
  overlayOpacity = 0.5,
  textAlign = "left",
  minHeight = "500px",
  animateTitle = true,
  animateSubtitle = true,
}) => {
  return (
    <section
      className={`${styles.heroSection} animate__animated animate__fadeIn`}
      style={{
        backgroundImage: `url(${backgroundImage})`,
        minHeight: minHeight,
        backgroundColor: "#000", // fallback
      }}
    >
      <div
        className={styles.heroOverlay}
        style={{ opacity: overlayOpacity }}
      />
      <div
        className={styles.heroContent}
        style={{ textAlign: textAlign }}
      >
        <h1
          className={`${styles.heroTitle} ${
            animateTitle ? "animate__animated animate__fadeInDown" : ""
          }`}
        >
          {title}
        </h1>
        <p
          className={`${styles.heroSubtitle} ${
            animateSubtitle
              ? "animate__animated animate__fadeInUp animate__delay-1s"
              : ""
          }`}
        >
          {subtitle}
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
